"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function MainHero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  return <section id="главен-герой" ref={ref} className="dark bg-background text-foreground relative min-h-[80vh] md:min-h-screen flex items-center justify-center overflow-hidden !bg-[url(/img/img-0147514a8efc2fafe02a54fdd04df7d4-v.webp)] !bg-[url(https://first-ladybird.10web.cloud/wp-content/uploads/2026/02/IMG-0147514a8efc2fafe02a54fdd04df7d4-V.webp)]">
      
      {}
      <div className="absolute inset-0 bg-dark-background/70" aria-hidden="true" />

      {}
      <div className={`container relative z-10 text-center transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"}`}>
        {}
        <h1 className="text-[48px] font-display font-bold leading-[1.1] tracking-tight mb-6 !text-[hsl(0,0%,100%)] md:text-[64px] lg:text-[72px]">Бързо. Домашно. Невероятно вкусно.</h1>

        {}
        <p className="text-[18px] leading-[1.6] max-w-2xl mx-auto mb-10 !text-[hsl(0,0%,100%)] md:text-[20px] lg:text-[22px]">Модерно заведение за бързо хранене в София "Миш-Маш /интерпред/" – вкусна домашна храна от висококачествени подбрани продукти</p>

        {}
        <Link to="/AboutUsPage">
          <Button size="lg" className="btn-primary text-[17px] px-10 py-4 h-auto shadow-medium hover:shadow-clay-hover cursor-pointer">Повече за нас</Button>
        </Link>
      </div>
    </section>;
}